var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduction-content5"},[_vm._m(0),_c('div',{staticClass:"content-container"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title-text"},[_vm._v("公司愿景")]),_c('div',{staticClass:"title-text-en"},[_vm._v("Corporate Vision")])])
}]

export { render, staticRenderFns }